import { render } from "./instructor-notifications.vue?vue&type=template&id=22924628"
import script from "./instructor-notifications.vue?vue&type=script&lang=js"
export * from "./instructor-notifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__